import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./svg-icon.css";


function SVGIcon({ name, flip, rotate, className }) {
    var useTag = `<use xlink:href="#${name}" />`;
    let inlineStyles = {};
    if (rotate) {
        inlineStyles["transform"] = `rotate(${rotate}deg)`;
    } else if (flip) {
        inlineStyles["transform"] = "rotateY(180deg)";
    }
    return (
        <svg
            style={inlineStyles}
            className={classnames(styles.svgIcon, `svg-icon-${name}`, className)}
            dangerouslySetInnerHTML={{ __html: useTag }}
        />
    );
}

export default SVGIcon;

SVGIcon.propTypes = {
    flip: PropTypes.bool,
    name: PropTypes.string.isRequired,
    rotate: PropTypes.number,
    className: PropTypes.string,
};
SVGIcon.defaultProps = {
    flip: false,
};
